<template>
  <div class="animated fadeIn">
    <b-card>
      <template slot="header"><i class='fa fa-align-justify'></i>Site List</template>
      <!-- detail search start -->
      <b-card v-show="so.adv">
        <b-row>
          <b-col md="6">
            <b-form-group>
              <label for="opt_date"> Registed Date
                <b-button size="sm" variant="info" @click="set_sd('', 'created_at')"><i class="fa fa-remove"></i></b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1d', 'created_at')">-1D</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1w', 'created_at')">-1W</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1m', 'created_at')">-1M</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('w', 'created_at')">W</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('m', 'created_at')">M</b-button>
              </label>
              <b-form inline>
                <date-picker @change="refresh" v-model="so.opt.created_at_sd" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
                ~
                <date-picker @change="refresh" v-model="so.opt.created_at_ed" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
              </b-form>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group>
              <label for="opt_visit"> Last Visit
                <b-button size="sm" variant="info" @click="set_sd('', 'last_visit')"><i class="fa fa-remove"></i></b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1d', 'last_visit')">-1D</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1w', 'last_visit')">-1W</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1m', 'last_visit')">-1M</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('w', 'last_visit')">W</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('m', 'last_visit')">M</b-button>
              </label>
              <b-form inline>
                <date-picker @change="refresh" v-model="so.opt.last_visit_sd" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
                ~
                <date-picker @change="refresh" v-model="so.opt.last_visit_ed" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
              </b-form>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <b-form-group>
              <label for="opt_name">Name</label>
              <b-form-input @keydown.enter="refresh" type="text" id="opt_name" v-model="so.opt['name']"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group>
              <label for="opt_FQDN">FQDN(URL)</label>
              <b-form-input @keydown.enter="refresh" type="text" id="opt_FQDN" v-model="so.opt['fqdn']"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="4">
            <b-form-group>
              <label for="opt_status">Status</label>
              <br>
              <c-switch color="info" @change="refresh" label size="sm" v-model="so.opt['is_alive']" />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <label for="ph_search_opt_type">Match Type</label>
            <b-form-group>
              <b-form-radio-group id="ph_search_opt_type" v-model="so.opt['match_type']" name="ph_search_opt_type">
                <b-form-radio value="and">[AND]:Match all</b-form-radio>
                <b-form-radio value="or">[OR]:Match at least one</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-form-group class="float-right">
          <b-button size="sm" variant="success" @click="refresh"> Search </b-button>
          <b-button size="sm" variant="warning" @click="reset"> Reset </b-button>
          <b-button size="sm" variant="secondary" @click="search_opt"> Close </b-button>
        </b-form-group>
      </b-card>
      <!-- detail search end -->

        <b-row>
          <b-col sm="6">
            <span class="text-center" v-b-tooltip.hover title="can see the log real-time">
              Show Count
              <select v-model="so.perPage" @change="refresh">
                <option disabled value="15">Default 15</option>
                <option value=10>10</option>
                <option value=50>50</option>
                <option value=100>100</option>
              </select>
            </span>
          </b-col>
          <b-col sm="6">
            <b-input-group size="sm">
              <b-input-group-prepend>
                <b-btn :disabled="so.adv" variant="outline-secondary" @click="refresh()"><i class="fa fa-refresh"></i></b-btn>
                <b-btn :disabled="so.adv" variant="outline-secondary" @click="reset()"><i class="fa fa-remove"></i></b-btn>
                <b-dropdown :disabled="so.adv" :text="so.skt || 'search'" size="sm" variant="outline-secondary">
                  <b-dropdown-item size="sm" @click="so.sk='fqdn'; so.skt='FQDN'">FQDN</b-dropdown-item>
                  <b-dropdown-item size="sm" @click="so.sk='name'; so.skt='name'">Name</b-dropdown-item>
                </b-dropdown>
              </b-input-group-prepend>
              <b-form-input :disabled="so.adv" v-model="so.sv" @keyup.native.enter="refresh"></b-form-input>
              <b-input-group-append>
                <b-btn variant="outline-secondary" @click="refresh()"><i class="fa fa-search"></i></b-btn>
                <b-btn variant="outline-secondary" @click="search_opt"><i class="fa" :class="{'fa-search-plus': !so.adv, 'fa-search-minus': so.adv }"></i></b-btn>
              </b-input-group-append>
            </b-input-group>
          </b-col>
        </b-row>
        <hr>
        <b-table hover striped small responsive="sm" foot-clone ref="_list" show-empty empty-text="not found"
          :items="getItems" :fields="fields" :current-page="so.currentPage" :per-page="so.perPage" :sortBy="so.sk">
          <template slot="id" slot-scope="row">{{startRow - row.index}}</template>
          <template slot="group" slot-scope="row">{{row.item.group ? row.item.group.groupname : '-'}}</template>
          <template slot="is_alive" slot-scope="row">
            <c-switch color="info" label size="sm" v-model="row.item.is_alive" @change="toggle_index = row.index; status_toggle_modal(row.index, row.item.is_alive)" />
          </template>
          <template slot="name" slot-scope="row">
            <del v-if="row.item.is_del">{{row.item.name}}</del>
            <template v-else>{{row.item.name}}</template>
          </template>
          <template slot="fqdn" slot-scope="row">{{row.item.fqdn}}</template>
          <template slot="last_visit" slot-scope="row">{{row.item.last_visit | utcsdate}}</template>
          <template slot="func" slot-scope="row">
            <b-btn @click="detail(row.item.id)" size="sm" variant="outline-primary">More</b-btn>
          </template>
        </b-table>
        <hr>
        <b-row>
          <b-col class="md-6">
            <b-pagination size="sm" :limit="10" :total-rows="rowCount" :per-page="so.perPage" v-model="so.currentPage" prev-text="Prev" next-text="Next" />
          </b-col>
          <b-col class="md-4">
            <div class="pull-right">
              <!-- 디버깅용 -->
              <!-- <b-button class="mr-2" size="sm" variant="outline-warning" @click="deleteAll"> DELETEALL_SCHEDULE </b-button> -->
              <!-- <b-button v-if="enable_new != false" class="mr-2" size="sm" variant="outline-warning" @click="upload"> Upload Multi Site </b-button> -->
              <!-- <b-button v-if="sites.length > 0 && enable_new != false" size="sm" variant="outline-primary" @click="$emit('count', 0); check_policy()">Quick Setup Guide </b-button> -->
              <!-- <b-button v-if="enable_new != false" class="mr-2" size="sm" variant="success" @click="check_policy"> New registration </b-button> -->
            </div>
          </b-col>
        </b-row>
      </b-card>
    <router-view @hide-parent="hideList($event)" @refresh="refresh()"></router-view>
    <b-modal title="Usage Status Change"  class="modal-danger" no-close-on-backdrop v-model="toggle_confirm" hide-footer @ok="status_toggle_api" ok-variant="danger" header-variant="danger">
      <div class="d-block text-center">
        <h3>Are you change status ?</h3>
        <hr>
        <h5>This change of setting affects billing</h5>
        <hr>
        <p class="text-danger">
          Site inspection issues will guide you through unused processing.
          <hr>
          <p class="text-dark">
            <b-checkbox v-model="is_mail">Notice to Group </b-checkbox>
          </p>
        </p>
      </div>
      <hr>
      <b-button class="mt-2" variant="outline-warning" block @click="status_toggle_api">Appy</b-button>
      <b-button class="mt-3" variant="outline-danger" block @click="status_toggle_modal(-1, false)">Close</b-button>
    </b-modal>
  </div>
</template>

<script>
import moment from 'moment-timezone';
import DatePicker from 'vue2-datepicker';
import custom from '@/custom';
import codes from '@/codes';
// import 'vue2-datepicker/index.css';
import { Api } from '@/service';
import { Switch as cSwitch } from '@coreui/vue';

export default {
  components : { DatePicker, cSwitch },
  name : "siteList",
  props: ['policy_id', "view_detail", "enable_new"],
  watch: {
    policy_id() {
      console.log("watch updated props data", this.policy_id)
      this.$refs._list.refresh();
    }
  },
  data: () => ({
    save_username: false,
    custom,
    so : Object.assign({}, codes.DEFAULT_OPT, { opt : {} }),
    limit : 15,
    sites : [],
    toggle_confirm : false,
    toggle_index : -1,
    change_to_disable : [],
    change_to_enable : [],
    is_mail : false,
  }),
  computed: {
    fields : function() {
      return [
        { key: 'id', label: 'No.', sortable: false, thStyle: 'width: 10%' },
        { key: 'group', label: 'Group', sortable: false },
        { key: 'is_alive', label: 'Status', sortable: false },
        { key: 'fqdn', label: 'URL', sortable: false },
        { key: 'name', label: 'Name', sortable: false },
        { key: 'last_visit', label: 'Last Visit', sortable: true },
        { key: 'func', label: 'More', sortable: false, thStyle: 'width: 10%'  },
      ]
    },
    startRow : function() { return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage; },
    rowCount: function() { return this.so.totalRows || 0; }
  },
  methods: {
    status_toggle_modal(index, is_alive) {
      // 처음에 초기화 하는 함수
      if(index == -1) { this.sites[this.toggle_index].is_alive = !this.sites[this.toggle_index].is_alive; this.toggle_confirm = false; return }
      else if(is_alive == false && this.change_to_disable.indexOf(index) > -1) { this.toggle_confirm = true; }
      else if(is_alive == true && this.change_to_enable.indexOf(index) > -1) { this.toggle_confirm = true; }

      console.log(is_alive == false && index, this.change_to_disable)
    },
    status_toggle_api() {
      let model = this.sites[this.toggle_index]
      if(model.is_alive) {
        let index = this.change_to_enable.indexOf()
        if(index > -1) {
          this.change_to_enable.splice(index, 1)
        }
      } else {
        let index = this.change_to_disable.indexOf()
        console.log("toggle to remove", index)
        if(index > -1) {
          this.change_to_disable.splice(index, 1)
        }
      }

      return Api.Manager_Call('wmds.site', 'update', Object.assign({}, { id : model.id, is_alive : model.is_alive, is_mail : this.is_mail }))
        .then(() => {  this.toggle_confirm = false; this.refresh(); this.$toastr.s('Saved') })
        .catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText))
    },
    search_opt() {
      this.so.adv = !this.so.adv;
      if(this.so.adv) {
        this.so.opt['created_at_ed'] = moment().add(1, "day");
        this.so.opt['last_visit_ed'] = moment().add(1, "day");
        this.so.opt['is_alive'] = true;
        this.so.opt['match_type'] = 'and';
        this.so.sv = ''
      } else { this.reset(); }
    },
    set_op(k, v) {
      if(v === false || v === true) { return { name : k, value : v === false ? false : true, op : '=' } }
      return { name : k, value : `%${v}%`, op : 'like' }
    },
    set_sd(v, k = 'created_at') {
      let opt = this.so.opt;

      if(!v) { delete opt[`${k}_sd`]; delete opt[`${k}_ed`]; }
      else {
        let ed = opt[`${k}_ed`] || moment().startOf('d');
        let sd = opt[`${k}_sd`] || ed;
        switch(v) {
          // case '+1d' : sd = moment(sd).subtract(-1, 'd'); break;
          case '-1d' : sd = moment(sd).subtract(1, 'd'); break;
          case '-1w' : sd = moment(sd).subtract(1, 'w'); break;
          case '-1m' : sd = moment(sd).subtract(1, 'M'); break;
          case 'w' : sd = moment(ed).startOf('isoweek'); break;
          case 'm' : sd = moment(ed).startOf('month'); break;
        }
        opt[`${k}_sd`] = sd.format('YYYY-MM-DD');
      }
      this.so.opt = Object.assign({}, this.so.opt, opt);
    },
    // TODO : 테스트 용도임, 배포하면 안됨
    // async deleteAll() {
    //   let rs = await Api.Manager({ target : 'site', cmd : 'clean' })
    //   console.log(rs)
    //   this.refresh()
    // },
    async check_policy() {
      if(this.sites.length < 1) { this.$emit('count', 0); return this.$router.push({ name: 'wmds_site', params: { id : 'add' } }) }

      let rs = await Api.Manager({ target : 'wmds.policy', cmd : 'list' })
      if(rs.error) { return this.$toastr.e('policy load failed') }
      if(rs.total == 0 ){ this.$toastr.w('Please register at least one policy'); this.$router.push({ name : 'wmds_policy', params : { id : 'add' } }) }
      else{ this.$router.push({ name: 'wmds_site', params: { id : 'add' } }) }
    },
    reset() { this.so = Object.assign({}, codes.DEFAULT_OPT, { opt : {} }); this.refresh(); },
    refresh() { this.$refs._list.refresh(); this.change_to_disable = []; this.change_to_enable = []; },
    getItems: function(ctx) { return this.load(ctx); },
    load(ctx = {}) {
      this.change_to_enable = []
      this.change_to_disable = []
      let so = {
        target : 'wmds.site', cmd : 'list',
        body : {
          sort : [{ name : "id", op : "desc" }],
          or : [],
          and : []
        },
        offset : (this.so.currentPage-1 || 0) * Number(this.so.perPage), limit: Number(this.so.perPage), // 10 은 나중에 변수 처리해야함.
      }

      if(ctx.sortBy) { so.body.sort = [ { name : ctx.sortBy, op : !ctx.sortDesc && 'desc' } ]; }
      if(this.policy_id) { so.body.and.push({ name : 'policy_id', value : this.policy_id, op : '='}) }
      if(this.so.sv && this.so.sk) { so.body.and.push(this.set_op(this.so.sk, this.so.sv, so)); }

      if(this.so.adv && this.so.opt) {
        var k = Object.keys(this.so.opt)
        for (let i = 0; i < k.length; i++) {
          if(k[i] == 'match_type') { continue; }
          let cond = undefined;

          switch (k[i]) {
            case 'created_at_sd':
              if(!this.so.opt[k[i]]) { this.$toastr.w("start Time is require", "notice"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : ">=" }
              break;
            case 'created_at_ed':
              if(!this.so.opt[k[i]]) { this.$toastr.w("end Time is require", "notice"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : "<" }
              break;
            case 'last_visit_sd':
              if(!this.so.opt[k[i]]) { this.$toastr.w("start Time is require", "notice"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : ">=" }
              break;
            case 'last_visit_ed':
              if(!this.so.opt[k[i]]) { this.$toastr.w("end Time is require", "notice"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : "<" }
              break;
            default:
              cond = this.set_op(k[i], this.so.opt[k[i]]);
              break;
          }
          if(cond.value == '%%' || cond.value === '') { continue; }
          if(this.so.opt['match_type'] == "and") { so.body.and.push(cond) }
          else { so.body.or.push(cond) }
        }
      }
      return Api.Manager(so)
        .then(rs => {
          this.so.totalRows = rs.total;
          this.sites = rs.body ? rs.body : [];

          this.sites.forEach((s, index) => {
            try {
              s.is_alive && this.change_to_disable.indexOf(index) < 1 ?  this.change_to_disable.push(index) : ''
              !s.is_alive && this.change_to_enable.indexOf(index) < 1 ?  this.change_to_enable.push(index) : ''
            } catch (e) { console.error(e) }
          })
          this.$emit('count', this.sites.length)
          return this.sites;
        }).catch(e => {
          this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText)
        })
    },
    detail: function(site_id) { this.policy_id ? this.$router.push({ name : 'wmds_site', params : { id : site_id } })  : this.$router.push(`site/${site_id}`) },
    upload: function() { this.$router.push({ name : 'wmds_site', params : { id : 'csv' } }) },
    hideList: function(e) {
      this.show = !e; console.log('site.list.vue', 'got event (list show/hide)', !e ? 'show' : 'hide')
    }
  },
  created: function() { console.log('site.list.vue', 'created'); },
  destroyed: function() { console.log('site.list.vue', 'destroyed'); },
  mounted: function() { console.log('site.list.vue', 'mounted'); },
}
</script>
